<template>
  <div :class="classes">
    <div class="image-wrapper">
      <Image
        :defaultSrc="defaultSrc"
        :altTag="altTag"
        :defaultWidth="defaultWidth"
        :defaultHeight="defaultHeight"
        :imageSrcset="imageSrcset"
        :imageCaption="imageCaption"
        :imageRoundedCorners="imageRoundedCorners"
        :imageCaptionPosition="imageCaptionPosition"
        :imageForceAspectRatio="imageForceAspectRatio"
        :imageForceAspectRatioMobile="imageForceAspectRatioMobile"
        :imageHorizontalFocus="imageHorizontalFocus"
        :imageVerticalFocus="imageVerticalFocus"
      />
      <VideoDialog v-if="videoDialog" v-bind="videoDialog" />
    </div>
    <Heading
      v-if="headline"
      :tag="tag"
      :role="headingRole"
      :size="headingSize"
      :content="headline"
      class="headline overflow-visible clear-none"
    />
    <div
      v-if="text"
      class="text-content overflow-visible clear-none"
      v-html="text"
    ></div>
    <div
      v-if="buttons && buttons.length > 0"
      class="buttons clear-both flex gap-2 flex-wrap mt-4"
    >
      <LinkButton
        v-for="(button, index) in buttons"
        :key="index"
        :url="button.url || '#'"
        :target="button.target"
        buttonType="outlined"
      >
        {{ button.title }}
      </LinkButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import './MediaBlockWithWrapText.scss';
import Image, { type ImageProps } from 'ewi-ui/components/1-atoms/Media/Image';
import Heading from 'ewi-ui/components/1-atoms/Heading';
import LinkButton from 'ewi-ui/components/1-atoms/LinkButton';
import { computed } from 'vue';
import VideoDialog, {
  type VideoDialogProps,
} from 'ewi-ui/components/2-molecules/VideoDialog';

export interface ButtonConfig {
  title: string;
  url?: string;
  target?: '_self' | '_blank';
  style?: string;
}

export interface MediaBlockWithWrapTextProps extends ImageProps {
  background?: '' | 'light' | 'lightgrey' | 'grey' | 'dark' | 'lightblue';
  imagePosition?: 'left' | 'right';
  videoDialog?: VideoDialogProps;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  headingRole?: 'display' | 'headline' | 'title' | 'label' | 'body' | 'extra';
  headingSize?: 'small' | 'medium' | 'large';
  headline?: string;
  text?: string;
  buttons?: ButtonConfig[];
}

const props = withDefaults(defineProps<MediaBlockWithWrapTextProps>(), {
  imagePosition: 'left',
  tag: 'h2',
  headingRole: 'headline',
  headingSize: 'large',
  buttons: () => [],
});

const classes = computed(() => ({
  'm-media-block-wrap': true,
  [`bg-${props.background}`]: props.background !== '',
  [`image-position-${props.imagePosition}`]: true,
}));
</script>
